export const BASE_LOGIN_FRAME_WIDTH = 412;
export const BASE_LOGIN_FRAME_HEIGHT = 876;
export const STATUS_BAR_OFFSET_Y = 42;
export const BASE_LOGIN_CANVAS_HEIGHT =
  BASE_LOGIN_FRAME_HEIGHT - STATUS_BAR_OFFSET_Y;
